import script from "./MyContactInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MyContactInfo.vue?vue&type=script&setup=true&lang=js"

import "./MyContactInfo.vue?vue&type=style&index=0&id=96078f48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96078f48"]])

export default __exports__